import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = ''

const pinSlice = createSlice({
  name: 'pin',
  initialState,
  reducers: {
    setPIN(state, action: PayloadAction<string>) {
      return (state = action.payload)
    }
  },

});

// Reducer
export default pinSlice.reducer;

// Actions
export const { setPIN } = pinSlice.actions;

